/* import __COLOCATED_TEMPLATE__ from './composer-tip-close-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./composer-tip-close-button.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());